import './ActionsMenu.scss';
import { ReactElement, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
import { Button } from '@Components/Button/Button';
import { Appearance, Design, Placement, PlacementType, Size } from '@Components/designConstants';
import { IconButton } from '@Components/IconButton';

export interface ActionsMenuItem {
  key: string;
  label: string;
  icon: ReactElement;
  onClick: () => void;
}

interface ActionsMenuProps {
  items: ActionsMenuItem[];
  popoverId: string;
  placement?: PlacementType;
  menuTestId?: string;
  toggleTestId?: string;
}

export const ActionsMenu = ({
  items,
  popoverId,
  placement = Placement.LEFT_START,
  menuTestId,
  toggleTestId
}: ActionsMenuProps) => {
  const [show, setShow] = useState(false);

  // react-bootstrap's OverlayTrigger only closes on outside-click/escape by default, so an
  // item click inside it never closes the menu unless `show` is driven by state and each
  // action clears it before running.
  const runAndClose = (action: () => void) => () => {
    setShow(false);
    action();
  };

  return (
    <OverlayTrigger
      show={show}
      onToggle={setShow}
      trigger={[]}
      placement={placement}
      overlay={
        <Popover id={popoverId}>
          <div className='actions-menu' data-testid={menuTestId}>
            {items.map(item => (
              <Button
                key={item.key}
                appearance={Appearance.EMPTY}
                design={Design.NEUTRAL}
                size={Size.MD}
                leadingElement={item.icon}
                onClick={runAndClose(item.onClick)}
                className='actions-menu-item'
              >
                {item.label}
              </Button>
            ))}
          </div>
        </Popover>
      }
    >
      <IconButton data-testid={toggleTestId} onClick={() => setShow(current => !current)}>
        <MdMoreHoriz />
      </IconButton>
    </OverlayTrigger>
  );
};
